export default "__VITE_ASSET__D2vq9lxz__"